var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    id: "svg60",
    viewBox: "-4.12599 -7.65905 35.75858 45.9543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs38"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 21.86,
    x2: -5.9,
    y1: 1.87,
    x1: 14.09,
    id: "linear-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    stopColor: "#008eff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    stopColor: "#008fff",
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop8",
    stopColor: "#00acff",
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop10",
    stopColor: "#00c0ff",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop12",
    stopColor: "#00cdff",
    offset: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop14",
    stopColor: "#00d1ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 15.32,
    x2: -2.37,
    y1: 15.32,
    x1: 26.45,
    id: "linear-gradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop17",
    stopColor: "#ffd800",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop19",
    stopColor: "#ff8a00",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 45.15,
    x2: -9.41,
    y1: 18.05,
    x1: 17.69,
    id: "linear-gradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop22",
    stopColor: "#ff3a44",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop24",
    stopColor: "#b11162",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 3.81,
    x2: 8.92,
    y1: -8.29,
    x1: -3.19,
    id: "linear-gradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop27",
    stopColor: "#328e71",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop29",
    stopColor: "#2d9571",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop31",
    stopColor: "#15bd74",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop33",
    stopColor: "#06d575",
    offset: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop35",
    stopColor: "#00de76",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-7{opacity:.07}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.004)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M.55.48A2.39 2.39 0 000 2.15v26.34a2.41 2.41 0 00.55 1.67l.09.09 14.75-14.76v-.35L.64.39z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M20.31 20.41l-4.92-4.92v-.35l4.92-4.91.11.06 5.83 3.31c1.67.94 1.67 2.49 0 3.44l-5.83 3.31z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M20.42 20.35l-5-5L.55 30.16a2 2 0 002.45.07l17.39-9.88",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M20.42 10.29L3 .4A1.93 1.93 0 00.55.48l14.84 14.84z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M20.31 20.24L3 30.06a2 2 0 01-2.39 0l-.09.09.09.09a2 2 0 002.39 0l17.39-9.88z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M.55 30A2.43 2.43 0 010 28.32v.17a2.41 2.41 0 00.55 1.67l.09-.09z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M26.25 16.86l-5.94 3.38.11.11L26.25 17a2.11 2.11 0 001.25-1.72 2.21 2.21 0 01-1.25 1.58z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M3 .58l23.25 13.19a2.2 2.2 0 011.25 1.55 2.09 2.09 0 00-1.25-1.72L3 .4C1.36-.54 0 .24 0 2.15v.17C0 .42 1.36-.37 3 .58z",
    fill: "#fff",
    opacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.61ac97c79c430c26cfeb34f062b04d18.svg";
export { ForwardRef as ReactComponent };